function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_83",
  "data-name": "Group 83",
  transform: "translate(-8301 -9224)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_23",
  "data-name": "Ellipse 23",
  transform: "translate(8301 9224)",
  fill: "none",
  stroke: "#df0000",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 24.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_82",
  "data-name": "Group 82",
  transform: "translate(-93.192 5.808)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_148848",
  "data-name": "Rectangle 148848",
  width: 24,
  height: 2,
  transform: "translate(8411.414 9234) rotate(45)",
  fill: "#df0000"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_148849",
  "data-name": "Rectangle 148849",
  width: 24,
  height: 2,
  transform: "translate(8410 9250.971) rotate(-45)",
  fill: "#df0000"
})));

var SvgFail = function SvgFail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fail.e09da9e3.svg";
export { ForwardRef as ReactComponent };